import React from "react";
export const AssignDefaultsModeContext = React.createContext({
  inAssignDefaultsMode: false,
  // eslint-disable-next-line @typescript-eslint/no-empty-function
  setAssignDefaultsMode: () => {
  }
});
export const workflowDefaultParamsObj = {
  taskNumber: void 0,
  workflowDefinitionName: void 0,
  workflowDefinitionId: void 0,
  workflowRunName: void 0,
  workflowRunId: void 0,
  toolName: void 0,
  workflowToolTitle: void 0,
  workflowToolDefinitionId: void 0,
  workflowTaskCode: void 0
};
export const WorkflowDefaultParamsContext = React.createContext(
  workflowDefaultParamsObj
);
